import { render, staticRenderFns } from "./ver-cursados.vue?vue&type=template&id=e0e078de&scoped=true"
import script from "./ver-cursados.vue?vue&type=script&lang=js"
export * from "./ver-cursados.vue?vue&type=script&lang=js"
import style0 from "./ver-cursados.vue?vue&type=style&index=0&id=e0e078de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e078de",
  null
  
)

export default component.exports